<template>
  <NuxtLink
    class="pointer link-btn"
    :class="disabled ? 'disabled' : ''"
    tabindex="0"
    :role="type"
    v-bind="$attrs"
    :to="href"
    @keydown.enter="handleActivate"
    @click="handleActivate"
  >
    <slot />
  </NuxtLink>
</template>
<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
    href?: string; // href has precedence over click event
  }>(),
  {
    type: "button",
    disabled: false,
    href: undefined,
  },
);
const emit = defineEmits<{
  click: [event: MouseEvent | KeyboardEvent];
}>();
const router = useRouter();

// Get attrs at the top level (outside computed)
const attrs = useAttrs();

// Determine if we should prevent default behavior based on target attribute
const shouldPreventDefault = computed(() => {
  // Get the target attribute from $attrs
  const target = attrs.target as string | undefined;
  // If target is _blank or _new, don't prevent default (let browser handle it)
  // Otherwise, prevent default to use Vue Router
  return !target || (target !== "_blank" && target !== "_new");
});

const handleActivate = (event: MouseEvent | KeyboardEvent) => {
  if (props.disabled) return;

  if (props.href) {
    // If shouldPreventDefault is true, we handle navigation with router.push
    if (shouldPreventDefault.value) {
      event.preventDefault?.();
      router.push(props.href);
    }
    // Otherwise, let the browser handle the navigation (target="_blank", etc.)
  }

  emit("click", event);
};
</script>
<style scoped lang="scss">
@use "@/sass/components/StoreLink.scss" as *;
</style>
